/**
 * Fetch VEEA license details by site id
 * @param {string} siteId
 * @returns {Promise<object|null>}
 */
export async function fetchVeeaDetails(siteId) {
	if (!siteId) return null

	try {
		const response = await fetch(
			`${process.env.REACT_APP_VEEA_SURVEILLANCE_ENDPOINT}/crowdkeep/license?site_id=${siteId}`
		)

		if (!response.ok) {
			console.error(`VEEA fetch failed: ${response.status}`)
			return null
		}

		return await response.json()
	} catch (error) {
		console.error("Error fetching VEEA details:", error)
		return null
	}
}

export async function fetchVeeaCameras(veeaHubAPIURL) {
	if (!veeaHubAPIURL) return null

	try {
		let url = `${veeaHubAPIURL}api/cameras`
		const response = await fetch(url)
		const data = await response.json()

		return data
	} catch (error) {
		console.error("Error fetching VEEA cameras:", error)
		return null
	}
}

export async function refreshLicenseDetails(veeaHubAPIURL) {
	if (!veeaHubAPIURL) return null

	try {
		const response = await fetch(`${veeaHubAPIURL}api/license/refreshLicenseFeatures`)

		if (!response.ok) {
			console.error(`VEEA license refresh failed: ${response.status}`)
			return null
		}

		return await response.json()
	} catch (error) {
		console.error("Error refreshing VEEA license:", error)
		return null
	}
}
